/* BX 10-10-2026 speed: stop Swiper from downloading every slider image when the page opens (preloadImages). Book covers already use loading="lazy", so they now load as they come into view. */
(function(){try{if(window.Swiper){var d={preloadImages:false,updateOnImagesReady:false};if(Swiper.extendDefaults)Swiper.extendDefaults(d);else if(Swiper.defaults)Object.assign(Swiper.defaults,d);}}catch(e){}})();
$(document).ready(function(){
  $('.h_accont_btn').on('click',function(e){
    e.preventDefault();
    $('.h_accont_dropdown').slideToggle();
    $(this).toggleClass('active');
  });
  
  $(document).on('click', 'body', function(e){
    var tag = $('.account_box');
    if (!tag.is(e.target) && tag.has(e.target).length === 0) {
      $('.h_accont_dropdown').hide();
    }
  });
  
  $('.mb_share_icon').on('click',function(e){
    e.preventDefault();
    $('.footer__list-social').toggleClass('active');
  });
  
  $('.colp_filter_head').on('click',function(e){
    e.preventDefault();
    $(this).toggleClass('active');
  });
  $(document).on('click', 'body', function(e){
    var tag = $('.colp_filter_head,.colp_filter_block');
    if (!tag.is(e.target) && tag.has(e.target).length === 0) {
      $('.colp_filter_head').removeClass('active');
    }
  });
  
  var next_arw = '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.16016 12H19.2618" stroke="#4DBDC6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.2109 5L19.2617 12L12.2109 19" stroke="#4DBDC6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var prev_arw = '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.2539 12L5.15229 12" stroke="#4DBDC6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.2031 19L5.15232 12L12.2031 5" stroke="#4DBDC6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';  
  /*if($('.flash_slider').length>0){
    $('.flash_slider').slick({
      infinite: false,
      slidesToShow:2,
      slidesToScroll:1,
      slide:'li',
      arrows:true,
      nextArrow:'<button class="slick-arrow slick-next">'+next_arw+"</button>",
      prevArrow:'<button class="slick-arrow slick-prev">'+prev_arw+"</button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1
          }
        }       
      ]
    });
  }
  if($('.home_Coll_slider').length>0){
    $('.home_Coll_slider').slick({
      infinite: true,
      slidesToShow:5,
      slidesToScroll:1,
      arrows:false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
  if($('.author_slider').length>0){
    $('.author_slider').slick({
      infinite: true,
      slidesToShow:6,
      slidesToScroll:1,
      arrows:true,
      nextArrow:'<button class="slick-arrow slick-next">'+next_arw+"</button>",
      prevArrow:'<button class="slick-arrow slick-prev">'+prev_arw+"</button>",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        }
      ]
    });
  }*/
  if($('.main_banner').length>0){
    $('.main_banner').slick({
     autoplay:true,
      autoplaySpeed:6000,
      infinite: true,
      slidesToShow:1,
      slidesToScroll:1,
      arrows:true,
      dots:true,
      appendDots: $('.slie_arw_inr'),
      prevArrow:'<button  type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"></path></svg></button>',
      nextArrow:'<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"></path></svg></button>',
      customPaging: function(slick, index) {
        return (
          '<a href="" aria-label="' +
          ( index + 1) +
          '" data-slide-number="' +
          index +
          '"></a>'
        );
      }
    });
    $('.slider_autoplay').on('click', function() {
      $('.main_banner').slick('slickPlay');
      $(this).removeClass('active');
      $('.slider_play').addClass('active');
    });
    $('.slider_play').on('click', function() {
      $('.main_banner').slick('slickPause');
      $(this).removeClass('active');
      $('.slider_autoplay').addClass('active');
    });
  }
  if($('.sale_slider').length>0){
    $('.sale_slider').slick({
      infinite: true,
      slidesToShow:1,
      slidesToScroll:1,
      arrows:true,
      centerMode: true,
      centerPadding: '26%',
      nextArrow:'<button class="slick-arrow slick-next">'+next_arw+"</button>",
      prevArrow:'<button class="slick-arrow slick-prev">'+prev_arw+"</button>",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            centerPadding: '20%'
          }
        },
        {
          breakpoint: 640,
          settings: {
            centerPadding: '10%'
          }
        }
      ]
    });
  }
  $('.md_arw').on('click',function(e){
    e.preventDefault();
    $(this).next('.md_submenu').slideToggle();
    $(this).toggleClass('active');
  });
  $('.mdaccount_title a').on('click',function(e){
    e.preventDefault();
    $('.md_acc_details').slideToggle();
    $(this).toggleClass('active');
  });
  $('.mobile_menu,.md_close').on('click',function(e){
    e.preventDefault();
    $('body').toggleClass('menu-open');
  });
  
  $('.psd_view_more').on('click',function(e){
    e.preventDefault();
    $(this).prev('.pro_short_desc').find('.psd_block').css('-webkit-line-clamp','unset');
    $(this).hide();
    $(this).prev('.pro_short_desc').removeClass('active');
    $(this).prev('.pro_short_desc').css('max-height','100%');
  });

//   =====Premium working=========
//   if($('.premium_slider').length>0){
//     $('.premium_slider').slick({
//       slidesToShow: 7,
//       draggable: true,
//       speed: 0,
//       slidesToScroll: 1,
//       arrows: true,
//       dots: false,
//       centerMode: true,
//       variableWidth: true,
//       infinite: true,
//       focusOnSelect: true,
//       cssEase: 'linear',
//       touchMove: true,
//       slide:'li',
//       nextArrow:'<button class="slick-arrow slick-next">'+next_arw+"</button>",
//       prevArrow:'<button class="slick-arrow slick-prev">'+prev_arw+"</button>"
//     });
//   }  
  
  
  
  
  /*if($('.hero_slider').length>0){      
    $('.hero_slider').slick({
      infinite: true,
      slidesToShow:3,
      slidesToScroll:1,
      arrows:true,
      nextArrow:'<button class="slick-arrow slick-next">'+next_arw+"</button>",
      prevArrow:'<button class="slick-arrow slick-prev">'+prev_arw+"</button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }*/
  /*function categorypage(){
    
    if($('.category_Coll_slider').length>0){
      $('.category_Coll_slider').slick({
        infinite: true,
        slidesToShow:4,
        slidesToScroll:1,
        arrows:false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 375,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    }
  }  
  categorypage();*/
  $(".policy-condition-table-content li a").on("click" , function(e){     
    $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 1000, 'linear');
  });
  $('.mob_filter,.mob_filter_close,.mob_filter_btn').on('click',function(e){
    e.preventDefault();
    $('body').toggleClass('open_filter');
  });
  
  $(document).on('click', 'body', function(e){
    var tag = $('.mob_filter,.mob_filter_close,.mob_filter_btn,.category_left');
    if (!tag.is(e.target) && tag.has(e.target).length === 0) {
      $('body').removeClass('open_filter');
    }
  });
  
  $('.cat_btn_left').on('click',function(e){
    e.preventDefault();
    $('.category_left').removeClass('active');
    $('.category_right').addClass('active');
    //$('.hero_slider').slick('refresh');
    //$('.category_Coll_slider').slick('refresh');
    $('.hero_slider').slick('refresh');
    //categorypage();
  });
  $('.cat_btn_right').on('click',function(e){
    e.preventDefault();
    $('.category_left').addClass('active');
    $('.category_right').removeClass('active');
    //$('.hero_slider').slick('refresh');
    //$('.category_Coll_slider').slick('refresh');
    $('.hero_slider').slick('refresh');
    //categorypage();
  });
  $('.mob_filter_sort,.sort_close').on('click',function(e){
    e.preventDefault();
    $('body').toggleClass('sortopen');
  });
  
  $(document).on('click', 'body', function(e){
    var tag = $('.mob_filter_sort,.sort_close,.mob_sorting_cls');
    if (!tag.is(e.target) && tag.has(e.target).length === 0) {
      $('body').removeClass('sortopen');
    }
  });
  
  if($('.customer_slider').length>0){
    $('.customer_slider').slick({
      infinite: true,
      slidesToShow:1,
      slidesToScroll:1,
      arrows:false,
      dots:true
    });
  }
  $('.pssowrd_eye').on('click',function(e){
    e.preventDefault();
    $(this).closest('.password_box').find('input').attr('type','text');
    $(this).closest('.password_box').find('.pssowrd_eyeline').show();
    $(this).hide();
  });
  $('.pssowrd_eyeline').on('click',function(e){
    e.preventDefault();
    $(this).closest('.password_box').find('input').attr('type','password');
    $(this).closest('.password_box').find('.pssowrd_eye').show();
    $(this).hide();
  });
  
//   var highestBox = 0;
//   $('.rflash_gridinr h4').each(function(){  
//     if($(this).height() > highestBox){  
//       highestBox = $(this).height();  
//     }
//   });    
//   $('.rflash_gridinr h4').height(highestBox);
//   $('.rflash_gridinr h4').hover(function(){
//     $(this).css('min-height',highestBox);
//   });
  
 
  
  $('.video_slider').slick({
    infinite: true,
    slidesToShow:1,
    slidesToScroll:1,
    arrows:true,
    nextArrow:'<button class="slick-arrow slick-next">'+next_arw+"</button>",
    prevArrow:'<button class="slick-arrow slick-prev">'+prev_arw+"</button>"
  });
  $('.video_btn').on('click',function(e){
  	e.preventDefault();
    $('.video_slide').find('.slideframe').removeClass('active')
    $(this).closest('.video_slide').find('.slideframe').addClass('active');
  });
  $(".video_slider").on('afterChange', function(event, slick, currentSlide){
    $('.slideframe').each(function(){
      $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');    
    });
  });
  $('.quantity__button').on('click',function(e){
//     console.log('d');
  	$('.update_btncls').trigger('click');
  });
  //   ======================GIFT POP UP JS ==================================
  
  /*
  function AddToCart(qty, variant_id, properites_wc){
    $.post('/cart/add.js', {
      items: [
        {
          quantity: qty,
          id: variant_id,
          properties: properites_wc
        }
      ]
    }, function(data){
//       console.log('sucess');
      var cartContents = fetch('/cart.js')
      .then(response => response.json())
      .then(data => { 
        if(data.item_count == 1){
          document.location.href = '/cart';
        }
      });
      
      
//       console.log('data',data);
      
      if($('.product-gift-cart-items .gift-wrapping-block input').prop("checked") == true){
      var t_count = 0;
      var line_items = new Array(); 

      $('.product-gift-cart-items .gift-inner-wrap').each(function(index){
        var title = $(this).find('input:checked').val();
        var total_length = $(".product-gift-cart-items .gift-inner-wrap input:checked").length;
        if($(this).find('input').prop("checked") == true){
          t_count++;
          var data_line = $(this).find('input:checked').data('line-item') + 1;  
          line_items.push({line:data_line, properties: { 'Gift Product': true }}); 
        }
      });

      function moveAlong(){
        if (line_items.length) {
          var request = line_items.shift();
          var tempQty = request.line;
          var tempProperties = request.properties;
          var params = {
            type: 'POST',
            url: '/cart/change.js',
            data: {line:tempQty, properties:tempProperties},
            //properties: { 'Custom_Bundle' : bundle_name },
            dataType: 'json',
            success: function(line_item) { 
//               jQuery.post('/cart/update.js', "attributes[Gift Wrap]=true&attributes[Gift Message]=Personalized Message is going to be here.")
              jQuery.post('/cart/update.js', "attributes[Gift Wrap]=true")
//               console.log("success!");
              moveAlong();
            },
            error: function() {
              console.log("fail");
              moveAlong();
            }
          };
          $.ajax(params);
        }
        else {
          document.location.href = '/cart';
        }  
      };
      moveAlong();



    }
      //window.location= '/cart'
    });
  }
  */
  
  
/*
  $(document).on('click','.gift-popup-submit',function(){
    var properites_wc = {} 
    var variant_id  = $('.gift-popup-submit').attr('id')
    var message = $('#gift-message').val().trim().length != 0
    var gift_option_1 = $('#gift-wrapping_option_1').is(":checked")
    var gift_option_2 = $('#gift-wrapping_option_2').is(":checked")
    
    console.log(properites_wc,variant_id,'variant_id');

    if(gift_option_1){
      properites_wc["gift-wrapping"] = "True"
      $('.product-gift-wrap_1').each(function(i){
        var option = $(this).is(':checked')
        if(option && $(this).val()){
          properites_wc[$(this).val()] =  "True"
        }
      })
    }

    if(gift_option_2){
      properites_wc["Include a message"] = "True"
      $('.product-gift-wrap_2').each(function(i){
        var option = $(this).is(':checked')
        if(option && $(this).val()){
          properites_wc[$(this).val()] =  "True"
        }
      })
      if(message){
        properites_wc["Gift Message"]= $('#gift-message').val();
      }
    }

    AddToCart(1, variant_id, properites_wc);    

//     console.log(properites_wc)
  })

  */



  $('#cstm_checkout').click(function(e){
    e.preventDefault();
    var qty = $('.quantity__input').val();
    var id= $(this).data('v_id')
   $.post('/cart/add.js', {
    items: [
      {
        quantity: qty,
        id: id
      }
    ]
  }, function(data){
    window.location= '/checkout'
  });  
  });
  
  
  $(".product-gift-overly,.product-gift-popup-close").on('click',function(){
    $(".product-gift-block").hide();
    $('body').removeClass('gift-block-active');
    $('.product-gift-item').attr('data-line-item','');
  });

  
  $(document).on('click','.product-gift-btn',function(e){
    $('#gift-inner-block-items').empty();
    e.preventDefault();
    $.getJSON('https://bookxcess-estore.myshopify.com/cart.json', function(e){
      var items_count= e.items
      console.log(items_count.length)
      for(var count= 1; count <= items_count.length; count++){
        var inner_html = '<div class="gift-inner-wrap"><input type="checkbox" id="gift-wrapping-'+count+'" value="'+items_count[count-1].title+'" class="product-gift-wrap-'+count+' product-gift-wrap-items" data-line-item="'+count+'" /><label for="gift-wrapping-'+count+'">'+items_count[count-1].title+'</label></div>'
        $('#gift-inner-block-items').append(inner_html)
      }
      $("#gift-wrapping-1, #gift-wrapping-2").prop('checked', true);
    });

    var id = $(this).attr('data-id');
    var data_line = $(this).parents('.gift_line_item').data('line-item');
    $('.product-gift-item').attr('data-line-item',data_line);
    $('.gift-popup-submit').attr('id',id);
    $('body').removeClass('CartOpen')
    $('body').addClass('gift-block-active');
    $(".product-gift-block").show();
  });
  

  $(document).on('click','.gift-popup-submit',function(){
    console.log('gift-popup-submit clicked');
    var properites_wc = {} 
    var variant_id  = $('.gift-popup-submit').attr('id')
    var data_line = $(this).parents('.product-gift-item').data('line-item');
    var message = $('#gift-message').val().trim().length != 0
    var gift_option_1 = $('#gift-wrapping_option_1').is(":checked")
    var gift_option_2 = $('.product-gift-wrap_2').is(":checked")
    
    properites_wc["gift-wrapping"] = "True"
    
    if(gift_option_2){
//       properites_wc[ $('.product-gift-wrap_2').val()] = "True"
//       $('.product-gift-wrap_2').each(function(i){
//         var option = $(this).is(':checked')
//         if(option && $(this).val()){
//           properites_wc[$(this).val()] =  "True"
//         }
//       });
      if(message){
        properites_wc["Gift Message"]= $('#gift-message').val();
      }
    }
    console.log('properites_wc', properites_wc)
    var newUpdateData = {
      id: variant_id,
      line: data_line,
      properties: properites_wc
    }
    
    
    
    var line_items = new Array(); 
    $('.product-gift-wrap-items').each(function(i){
      var wc_line_item = $(this).data('line-item')
      var wc_selected_item = $(this).data('line-item');
      var option = $(this).is(':checked')

	 console.log('wc_selected_item', wc_selected_item);
      if(option && $(this).val()){
        properites_wc[$(this).val()] =  "True"
        if( wc_selected_item != data_line){
          line_items.push({line: wc_line_item, properties: { 'Gift Product': 'true' }}); 
        } 
      }
      if( wc_selected_item == data_line ){
 		properites_wc["Gift Product"] = "true"
        line_items.push({line: data_line, properties: properites_wc}); 
      }
      console.log('wc_line_item', wc_line_item)
    })

	console.log('properites_wc', properites_wc);
    console.log('newUpdateData', newUpdateData)
    console.log('line_items', line_items)
//     debugger;
//     jQuery.ajax({
//       type: "POST",
//       url: "/cart/change.js",
//       data: newUpdateData,
//       dataType: "json",
//       success: function(data) {
//         console.log("Yay!  The cart updated!");
      
//         console.log(line_items)

        function moveAlong(){
//           debugger;
          console.log('moveAlong starting to call');
          if (line_items.length) {
            var request = line_items.shift();
            var tempQty = request.line;
            var tempProperties = request.properties;
            var params = {
              type: 'POST',
              url: '/cart/change.js',
              data: {line:tempQty, properties:tempProperties},
              //properties: { 'Custom_Bundle' : bundle_name },
              dataType: 'json',
              success: function(line_item) { 
                console.log('moveAlong success called');
                
                moveAlong();
              },
              error: function() {
                console.log("fail");
                moveAlong();
              }
            };
            $.ajax(params);
          }
          else {
            jQuery.post('/cart/update.js', "attributes[Gift Wrap]=true").done(function() {  document.location.href = '/cart'; });
           
          }  
        };
        moveAlong();


//         var cartContents = fetch('/cart.js')
//         .then(response => response.json())
//         .then(data => { 
//           if(data.item_count == 1){
//             document.location.href = '/cart';
//           }
//         });
//         if($('.product-gift-cart-items .gift-wrapping-block input').prop("checked") == true){
//           var t_count = 0;
//           var line_items = new Array(); 

//           $('.product-gift-cart-items .gift-inner-wrap').each(function(index){
//             var title = $(this).find('input:checked').val();
//             var total_length = $(".product-gift-cart-items .gift-inner-wrap input:checked").length;
//             if($(this).find('input').prop("checked") == true){
//               t_count++;
//               var data_line = $(this).find('input:checked').data('line-item') + 1;  
//               line_items.push({line:data_line, properties: { 'Gift Product': true }}); 
//               console.log('line_items',line_items);
//             }
//           });

//           function moveAlong(){
//             if (line_items.length) {
//               var request = line_items.shift();
//               var tempQty = request.line;
//               var tempProperties = request.properties;
//               console.log('tempProperties',tempProperties);
//               var params = {
//                 type: 'POST',
//                 url: '/cart/change.js',
//                 data: {line:tempQty, properties:tempProperties},
//                 //properties: { 'Custom_Bundle' : bundle_name },
//                 dataType: 'json',
//                 success: function(line_item) { 
//                   //               jQuery.post('/cart/update.js', "attributes[Gift Wrap]=true&attributes[Gift Message]=Personalized Message is going to be here.")
//                   jQuery.post('/cart/update.js', "attributes[Gift Wrap]=true")
//                   //               console.log("success!");
//                   moveAlong();
//                 },
//                 error: function() {
//                   console.log("fail");
//                   moveAlong();
//                 }
//               };
//               $.ajax(params);
//             }
//             else {
//               document.location.href = '/cart';
//             }  
//           };
//           moveAlong();
//         }
//       },
//       error: function() {
//         console.log("Oops!  Cart is not update!");
//       }
//     });
    
    
    
    
  });

// -----------------------------------
//   $('a.product-gift-btn').click(function (e) {
//     console.log('d')
//     e.preventDefault();
//     var attr = $('.product-gift-btn').attr('disabled');
//     if (typeof attr !== 'undefined' && attr !== false) {
//       console.log('if claed')
//       $('.product-gift-block').hide();
//     }else {
//       console.log('called')
//       $.getJSON('https://bookxcess-estore.myshopify.com/cart.json', function(e){
//         for(var count= 0; count <= e.items.length; count++){
//           console.log(e.items[count])
//         }
//       });
//       $('.product-gift-block').show();
//     };
    
//   });
// -----------------------------------

//   $("#gift-wrapping_option_1").change(function() {
//     if($(this).prop('checked')) {
//       $("#gift-wrapping-1, #gift-wrapping-2").prop('checked', true)
//     } else {
//       $("#gift-wrapping-1, #gift-wrapping-2").prop('checked', false)
//     }
//   });

  $(".product-gift-wrap_2").change(function(){
    if($(this).prop('checked')) {
      $('.gift-popup-submit').attr('disabled', true);
      $('#gift-message').attr('disabled', false);
      $("#gift-message").keyup(function(){
        var x = $('#gift-message').val().trim().length != 0
        if(!x){
          $('.gift-popup-submit').attr('disabled', true)
        }else{
          $('.gift-popup-submit').removeAttr('disabled', true)
        }
      });
    }else{
      $('.gift-popup-submit').removeAttr('disabled', true)
      $('#gift-message').attr('disabled', true)
    }
  });
  //   ======================GIFT POP UP JS ==================================

  //   ================================
  function NormalAddToCart(qty, id){
    $.post('/cart/add.js', {
      items: [
        {
          quantity: qty,
          id: id
        }
      ]
    }, function(data){
      window.location= '/cart'
    });  
  }
  function NormalAddToCart2(qty, id){
    $.post('/cart/add.js', {
      items: [
        {
          quantity: qty,
          id: id
        }
      ]
    }, function(data){
      //window.location= '/cart'
    });  
  }

//   $('button.grid_cartcls').click(function(){
//     var variant_id = $(this).data('id')
//     NormalAddToCart(1, variant_id)
//   });

  $('.product-checkout').click(function(){
    var id = $(this).data('variant-id')
    var qty = $('.quantity__input').val();
    NormalAddToCart(qty, id);
  });

  

  //   ================================


// $(document).on('click', 'a.button.wc_donate_product', function() {
  
//   console.log('without data')
  // 

  //   ==================DONATION PAGE(add to donate)=====================
//   $(document).on('click','a.button.wc_donate_product', function() {
//     var id = $(this).data('id')
//     var children_name = $(this).data('children-name')
    
//     var data = {
//       "Donation": true,
//       "Donation Type": "Make A Wish",
//       "Donation to": children_name
//     }
//     console.log('data', data)
//     $.post('/cart/add.js', {
//       items: [
//         {
//           quantity: 1,
//           id: id, 
//           properties: data
//         }
//       ]
//     }, function(data){
//       jQuery.post('/cart/update.js', "attributes[Donation Product]=true")
//     });
//   })
  //   =======================================
  
  
  
//   $(document).on('click','button.donation_cart_add_btn', function() {
//     var id = $(this).data('id')
//     var camp_name_isis = $('.donation-product-grid').data('camp_name_isis')
//     var qty= $('#Quantity-template--15049260204238__main').val();
// //     console.log('qtyyyyyyyyyy', qty)
//     var data = {
//       "Donation": true,
//       "Donation Type": "Organization",
//       "Donation to": camp_name_isis
//     }
//     //     console.log('data', data)

//     function add_to_donate(){
//       $.post('/cart/add.js', {
//         items: [
//           {
//             quantity: qty,
//             id: id, 
//             properties: data
//           }
//         ]
//       }, function(data){
//         jQuery.post('/cart/update.js', "attributes[Donation Product]=true")
//       });
//     }
    
//     $.getJSON('/cart.js', function(e){
//       console.log('e', e.items)
//       var cart_items = e.items
//       if(e.items.length > 0 ){
//         for(var counter = 0; counter<= cart_items.length; counter++){
//           console.log( cart_items[counter] )
//           if($.isEmptyObject(cart_items[counter].properties) || cart_items[counter].properties['gift-wrapping'] == "True" ){ 
//             console.log("Can't add this product, Normal products exists", cart_items[counter]);
//             break;
//           }else if(cart_items[counter].properties['Donation'] == "true"){
//         	add_to_donate();
//             console.log('add to donation called')
//             break;
//           }
//         }
//       }else{
//         console.log('add to donation called')
//         add_to_donate();
//       }

//     });
    
    
    
    
    
//   });

  
  
  
  
  });
function pro_desc(){
  if($( window ).width() > 992){
    var sum=0;
    $('.pro_overview_wrap ul li').each(function(){
      sum +=$(this).innerHeight();
      if($(this).hasClass("pro_publisher")){
        return false;
      }
    });
    var desc_height = $('.pro_overview_block').find('.pro_short_desc').innerHeight();
    if(sum < desc_height){
      console.log("height",sum,'desc',desc_height,'this',$(this));
      $('.pro_short_desc').addClass('active');
      $('.pro_overview_block').find('.pro_short_desc').css('max-height',sum+'px');
    }
  } else {
    $('a.menu-nav-link').click(function() {
     $(this).removeAttr('href');
    });
  }
}
$(document).ready(function(){
  pro_desc();
});
$(window).on('load',function(){
  pro_desc();
});
$( window ).resize(function() {
  pro_desc();
//   var highestBox = 0;
//   $('.rflash_gridinr h4').each(function(){  
//     if($(this).height() > highestBox){  
//       highestBox = $(this).height();  
//     }
//   });    
//   $('.rflash_gridinr h4').height(highestBox);
//   $('.rflash_gridinr h4').hover(function(){
//     $(this).css('min-height',highestBox);
//   });

  var heightAuthor = 0;
  $('.rflash_gridinr .f_g_author').each(function(){
    if($(this).height() > heightAuthor){
      heightAuthor = $(this).height();
    }
  });
  $('.rflash_gridinr .f_g_author').height(heightAuthor);

  var priceHeight = 0;
  $('.pro_grid_btm .pro_grid_price').each(function(){
    if($(this).height() > priceHeight){
      priceHeight = $(this).height();
    }
  });
  $('.pro_grid_btm .pro_grid_price').height(priceHeight);
});


/*var e = new Swiper(".home_Coll_slider", {
  slidesPerView: 3,
  spaceBetween: 0,
  freeMode: !0,
  watchSlidesVisibility: !0,
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  scrollbar: { el: ".swiper-scrollbar", draggable: !0 },
  breakpoints: {768: { slidesPerView: 3, spaceBetween: 0 }, 1024: { slidesPerView: 5, spaceBetween: 0 } },
});*/
var swiper = new Swiper(".home_Coll_slider", {
  slidesPerView:2,
  spaceBetween: 1,
  slidesPerGroup: 1,
  loop: true,
  loopFillGroupWithBlank: true,  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    400: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 0,
    },
    1200: {
      slidesPerView: 7,
      spaceBetween: 0,
    }
  },
});
var swiper = new Swiper(".category_Coll_slider", {
  slidesPerView:2,
  spaceBetween: 1,
  slidesPerGroup: 1,
  loop: true,
  freeMode: true,
  loopFillGroupWithBlank: true,  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {    
    576: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 0,
    },
  },
});
var swiper = new Swiper(".author_slider", {
  slidesPerView:2,
  spaceBetween: 0,
  slidesPerGroup: 1,  
  loop: true,
  freeMode: true,
  navigation: {
    nextEl: ".authornext",
    prevEl: ".authorprev",
  },
  breakpoints: {
    375: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
    950: {
      slidesPerView:5,
      spaceBetween: 0,
    },
    1366: {
      slidesPerView:6,
      spaceBetween: 0,
    },
  },
});
var swiperh = new Swiper(".hero_swiper", {
  slidesPerView:2,
  spaceBetween: 0,
  slidesPerGroup: 1,  
  loop: true,
  freeMode: true,
  navigation: {
    nextEl: ".heroslidernext",
    prevEl: ".herosliderprev",
  },
  breakpoints: {    
    700: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
});
var swiperv = new Swiper(".villians_swiper", {
  slidesPerView:2,
  spaceBetween: 0,
  slidesPerGroup: 1,  
  loop: true,
  freeMode: true,
  navigation: {
    nextEl: ".villian_slidernext",
    prevEl: ".villian_sliderprev",
  },
  breakpoints: {  
    700: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
});
var swipeflash = new Swiper(".flash_slider", {
  slidesPerView:1,
  spaceBetween: 0,
  slidesPerGroup: 1,  
  loop: false,
  freeMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {    
    576: {
      slidesPerView:2,
      spaceBetween: 0,
    },
    992: {
      slidesPerView:1,
      spaceBetween: 0,
    },
    1024: {
      slidesPerView:2,
      spaceBetween: 0,
    },
  },
});
$('.nhome_coll_outer').each(function(e){
  var this_slidecls = $(this).find('.nhome_collslider')[0];
  var prev_arwcls = $(this).find('.newswiper-button-prev')[0];
  var next_arwcls = $(this).find('.newswiper-button-next')[0];
  var width = $('.nhome_collslider .swiper-slide').width() / $('.nhome_collslider').width() * 100;
  var view_pro = parseInt(100 / width);
  console.log(width,view_pro);
  var proswiper = new Swiper(this_slidecls, {
    slidesPerView: "auto",
    slidesPerGroup: view_pro,
    spaceBetween: 0,
    navigation: {
      prevEl: prev_arwcls,
      nextEl: next_arwcls
    },
  });
});
$('.pro_banner').each(function(e){
  var this_bannercls = $(this).find('.pro_banner_slider')[0];
  var prev_arwcls = $(this).find('.newswiper-button-prev')[0];
  var next_arwcls = $(this).find('.newswiper-button-next')[0];
  var probanner = new Swiper(this_bannercls, {
    slidesPerView: "auto",
    spaceBetween: 0,
    navigation: {
      prevEl: prev_arwcls,
      nextEl: next_arwcls
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination",
    },
  });
});
$('.h_n_salebnners').each(function(e){
  var this_saleslidecls = $(this).find('.hn_sale_slider')[0];
  var prev_salearwcls = $(this).find('.swiper-button-prevs')[0];
  var next_salearwcls = $(this).find('.swiper-button-nexts')[0];
  var dataloop = $(this).find('.hn_sale_slider').data('loop');
  var saleswiper = new Swiper(this_saleslidecls, {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop:dataloop,
    navigation: {
      prevEl: prev_salearwcls,
      nextEl: next_salearwcls
    },
  });
});
$('.nba_sfull_bnr').each(function(e){
  var this_sec_bnr = $(this).find('.nba_sfull_slider')[0];
  var prev_sec_arwcls = $(this).find('.prev_sec_sale')[0];
  var next_sec_arwcls = $(this).find('.next_sec_sale')[0];
  var dataloop = $(this).find('.nba_sfull_slider').data('loop');
  var saleswiper = new Swiper(this_sec_bnr, {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop:dataloop,
    navigation: {
      prevEl: prev_sec_arwcls,
      nextEl: next_sec_arwcls
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination",
    },
  });
});


// $(document).ready(function(e){
//   function testpp(){
//     console.log('testpp function called');  
//   }
//   $.getJSON('/cart.js', function(e){
//     console.log('e', e.items)
//     var cart_items = e.items
//     if(e.items.length > 0 ){
//       for(var counter = 0; counter<= cart_items.length; counter++){
//         console.log( cart_items[counter] )
//         if($.isEmptyObject(cart_items[counter].properties) ){ 
//           console.log("Can't add this product, Normal products exists", cart_items[counter]);
//           break;
//         }else if(cart_items[counter].properties['gift-wrapping'] == "True" ) {
//           break;
//         }
//       }
//       testpp();

//     }else{
//       console.log('add to donation called')
//       testpp();
//     }

//   });
// });


if ($(window).width() <= 768) {
   // alert('Less than 768');
    Fancybox.bind("[data-fancybox]", {
    });
}






